import React from "react";
import { Theme, themeRootClassMap } from "apps/website/maps/Theme.map";
import Image, { IImageProps } from "apps/website/components/base/Image/Image";
import highlightTextWithHTML from "apps/website/utils/website/highlightTextWithHTML";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import TextControl from "apps/website/components/base/Text/TextControl/TextControl";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";

import { Divider } from "@/admin-components";

export interface VetAndExpertsCardItemProps {
  image: IImageProps;
  quote: string;
  author: string;
  jobTitle: string;
  backgroundTheme?: Theme;
}
const VetAndExpertsCardItem: React.FC<VetAndExpertsCardItemProps> = ({
  image,
  quote,
  author,
  jobTitle,
  backgroundTheme = "default",
}) => {
  const formatedQuote = highlightTextWithHTML({ text: quote });
  return (
    <div className="flex flex-col gap-4">
      <div className={`${themeRootClassMap[backgroundTheme]} `}>
        <Image
          image={ image }
          alt={ author }
          className="w-full h-full object-cover"
        />
      </div>
      <Divider />
      <TextSubtitle size={1}>
        <span dangerouslySetInnerHTML={{ __html: `&ldquo;${formatedQuote}&rdquo;` }} />
      </TextSubtitle>
      <div>
        <TextControl size={1} className="uppercase !mb-0">
          { author }
        </TextControl>
        <TextBody size={2}>
          { jobTitle }
        </TextBody>
      </div>
    </div>
  );
};

export default VetAndExpertsCardItem;
